
const setParentAnswerList = (state) => {
	const listString = JSON.stringify(state)
	localStorage.parentAnswerList = listString
}
const setPageMessage = (state) => {
	const listString = JSON.stringify(state)
	localStorage.pageMessageObj = listString
}
const setRadio = (state) => {
	localStorage.radio = state
}

export default {
	//保存token
	saveAuthorization(state, val) {
		state.Authorization = val;
		// sessionStorage.setItem('token', val);
	},
	//保存token
	saveRoutesPrivilege(state, val) {
		state.routesPrivilege = val;
		// sessionStorage.setItem('token', val);
	},
	//保存token
	saveMenuBtnPrivilege(state, val) {
		state.menuBtnPrivilege = val;
		// sessionStorage.setItem('token', val);
	},


	//保存菜单数据
	saveMenu(state, val) {
		state.menu = val;
	},
	//菜单code作为对象属性名,菜单数据作为值存储
	setMenuData(state, obj) {
		state.menuObject = {
			...state.menuObject,
			...obj
		}
	},
	//保存路由
	saveRoutes(state, val) {
		state.routes = val;
	},

	/*改变loading状态*/
	changeLoading(state, val) {
		state.isLoading = val;
	},

	//保存用户id
	saveOrgId(state, val) {
		state.orgId = val;
	},
	//保存机构代码
	saveOrgCode(state, val) {
		state.orgCode = val;
	},
	//设置父级问题的选中状态
	setQuestionstate(state, val) {

		let list = state.parentAnswer
		// console.log(list);
		
		if (list.length === 0) {
			list.push(val)
		}
		let result = list.some(item => { // 这里是判断关键  存在 返回 true  result=true
			if (item.id == val.id)
				return true
		})
		if (result) {
			// console.log("数组中该对象已存在")
			for (const i in list) {
				if (list[i].id === val.id) {
					list[i].value = val.value
				}
			}
		} else {
			// console.log("数组中不存在该项")
			list.push(val)
		}
		// console.log(list);
		setParentAnswerList(list)
	},
	setPageMessageList(state, val){
		let obj = state.pageMessage
		obj[val.name] = val.value
		setPageMessage(obj)
	},
	setRadio(state, val) {
		state.radio = val
		setRadio(state.radio)
	}
}
